import Image from "next/image";

import staticImg from "@public/public-qrcode.png";

/*
 * generated with https://www.qrcode-monkey.com/
 *
 * if we don't want it to be dynamic (at this time we don't), it's much more lightweight thing to generate a static png and use it instead.
 *
 * Otherwise check npm qr-code-styling or things like that
 *
 * */
export default function QRCodeWithLogo() {
  return <Image height={100} width={100} src={staticImg} alt="qr code" />;
}
